import React from 'react';
import Navigate from '../../routers/Navigate';

const LogoutCallbackPage = () => {
  return <Navigate to={'/'} />;
};

export default LogoutCallbackPage;
